<!-- eslint-disable -->
<template>
  <div class="form-default">
    <title-login :title="contentTitle"></title-login>
    <WorkspaceTitle></WorkspaceTitle>
    <form class="form" v-on:submit.prevent>
      <title-form :title="titleLogin"></title-form>
      <!-- <the-mask :masked="true" :mask="['###.###.###-##', '##.###.###/####-##']" /> -->
      <input-default
        v-for="input in inputs"
        :key="input.placeholder"
        :type="input.type"
        :values="input.values ? input.values : []"
        :name="input.name"
        :placeholder="input.placeholder"
      ></input-default>
      <button-game
        :disabeled="button.disabled"
        :name="button.name"
        :typeLogin="button.typeLogin"
        :action="button.action"
      ></button-game>
    </form>
				<div class="copyright"
					:style="{
						color: colors.theme !== 'dark' ? '#000' : '#fff',
						fill: colors.theme !== 'dark' ? '#000' : '#fff'
					}"				
				>
					<span>{{ $t("views.AccessOption.copyright") }}</span>
					<LogoHuddle></LogoHuddle>
				</div>
  </div>
</template>
<script>
import TitleLogin from "../Text/TitleLogin";
import WorkspaceTitle from "../Text/WorkspaceTitle";
import InputDefault from "../Inputs/InputDefault";
import ButtonGame from "../Buttons/ButtonGame";
import FooterDefault from "../Sections/FooterDefault";
import TitleForm from "../Text/TitleForm";
import LogoHuddle from "../customIcons/logoHuddle.vue";

export default {
  components: {
    TitleLogin,
    InputDefault,
    ButtonGame,
    FooterDefault,
    TitleForm,
    WorkspaceTitle,
    LogoHuddle
  },
  props: {
    contentTitle: {
      type: String,
      required: true
    },
    titleLogin: {
      type: String,
      required: true
    },
    inputs: {
      type: Array,
      required: true
    },
    button: {
      type: Object,
      required: true
    }
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
		this.game = localStorage.getItem("game-redirect");
  },  
};
</script>
<style lang="scss" scoped>
.form-default {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  	.copyright {
		margin: 40px 0 0 0;
		display: flex;
		flex-direction: column;
		align-items: center;

		span {
			letter-spacing: 2px;
			font-size: 12px;
			padding: 0 0 15px 0;
			text-transform: uppercase;
		}

		img,
		svg {
			max-width: 85px;
		}
	}

  .form {
    width: 85%;
    max-width: 400px;
    margin: 0 auto;
  }
}
</style>
